
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1fn7j_18k9z_93",
  "styled-box": "awsui_styled-box_1fn7j_18k9z_100",
  "styled-box-checked": "awsui_styled-box-checked_1fn7j_18k9z_106",
  "styled-box-indeterminate": "awsui_styled-box-indeterminate_1fn7j_18k9z_106",
  "styled-box-disabled": "awsui_styled-box-disabled_1fn7j_18k9z_110",
  "styled-line": "awsui_styled-line_1fn7j_18k9z_124",
  "styled-line-disabled": "awsui_styled-line-disabled_1fn7j_18k9z_129"
};
  